import React from 'react'

const MagGlass = (props: React.SVGProps<SVGSVGElement>): React.ReactElement => {
    return (
        <svg
            width="80"
            height="80"
            viewBox="0 0 80 80"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <circle cx="40" cy="40" r="40" fill="white" />
            <path
                d="M33.7599 27.8617C34.5446 27.0176 35.5054 26.3548 36.5747 25.9201C37.4935 25.6216 38.4657 25.5223 39.4261 25.6289C40.9854 25.8011 42.4817 26.3384 43.7927 27.1968C45.1036 28.0552 46.192 29.2103 46.9688 30.5678C48.0877 32.66 48.4817 35.0616 48.0898 37.3997C47.8199 39.6488 46.6787 41.704 44.9095 43.1274C40.9614 46.0276 36.3798 43.006 33.4675 39.5476C32.1515 37.9822 30.5796 35.4217 30.738 33.3467C31.0757 31.2245 32.1441 29.2854 33.7599 27.8617Z"
                fill="#EF8078"
            />
            <path
                d="M52.0623 50.8209C53.1102 52.8353 53.6708 53.442 55.2792 55.9782C57.2045 59.0119 58.1062 59.9827 54.7674 61.536C51.4287 63.0893 51.1118 64.3513 49.1378 59.109C48.0365 56.0718 46.4972 53.2104 44.5684 50.6146"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M46.8591 49.2918C46.8591 49.2918 39.5479 53.7817 30.2262 47.6415C22.5007 42.5448 22.915 30.5677 26.3513 25.5075C29.7875 20.4472 39.1458 15.6297 47.6389 22.1704C56.1321 28.7111 54.5724 37.339 53.0126 42.1808C51.2458 47.7264 49.2108 48.0541 48.1385 46.877C46.8469 45.4451 49.8079 44.1224 50.5756 47.0833C50.8238 47.9408 50.9698 48.4856 51.3542 49.2918"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M39.4017 46.1975C45.519 46.1975 50.4781 41.259 50.4781 35.1669C50.4781 29.0749 45.519 24.1364 39.4017 24.1364C33.2844 24.1364 28.3253 29.0749 28.3253 35.1669C28.3253 41.259 33.2844 46.1975 39.4017 46.1975Z"
                stroke="#686058"
                strokeMiterlimit="10"
            />
            <path
                d="M35.6122 34.184C35.6122 34.184 32.8339 30.3493 37.9761 28.7718C41.4246 27.6797 44.0688 32.4123 42.0947 34.4267C41.5343 34.9733 41.1433 35.6687 40.9683 36.4303C40.7933 37.1919 40.8417 37.9875 41.1077 38.7224"
                stroke="#686058"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M41.9729 41.2101C42.2287 41.2101 42.436 41.0036 42.436 40.749C42.436 40.4943 42.2287 40.2878 41.9729 40.2878C41.7172 40.2878 41.5099 40.4943 41.5099 40.749C41.5099 41.0036 41.7172 41.2101 41.9729 41.2101Z"
                stroke="#686058"
                strokeMiterlimit="10"
            />
        </svg>
    )
}

export default MagGlass
